import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { TenantService } from '../services/tenant.service';
import { ROUTE_CONSTANTS } from '../constants/route.constants';

@Injectable({ providedIn: 'root' })
export class TenantGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private tenantService: TenantService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isUserLoggedIn()) {
      return this.router.createUrlTree([ROUTE_CONSTANTS.LOGIN]);
    }

    const requested = route.paramMap.get('tenant');
    return this.tenantService.loadTenants().pipe(
      map(tenants => {
        const primary = tenants[0]?.name;
        if (!primary) {
          return this.router.createUrlTree([ROUTE_CONSTANTS.LOGIN]);
        }
        if (!requested || !this.tenantService.hasTenant(requested)) {
          return this.router.createUrlTree(this.tenantService.chatCommands(primary));
        }
        return true;
      }),
      catchError(() => of(this.router.createUrlTree([ROUTE_CONSTANTS.LOGIN])))
    );
  }
}
